<div class="full-height layout-column">

  <span *ngIf="!areaNames.length">---</span>

  <div *ngIf="areaNames.length" class="flex">
    <div *ngIf="areaNames.length < maxItems" class="flex layout-column br-body-2">
      <span *ngFor="let name of areaNames">{{name}}</span>
    </div>
    <span *ngIf="areaNames.length > (maxItems - 1)" class="br-body-2" [ngbTooltip]="tooltipTmpl" openDelay="300" triggers="hover">
      <b>{{areaNames.length}}</b> {{'Service Areas' | translate}}
      <ng-template #tooltipTmpl>
         <div layout="row" class="layout-column">
            <span *ngFor="let name of areaNames">{{name}}</span>
        </div>
      </ng-template>
    </span>
  </div>

</div>
